import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal-container position-fixed top-0 start-0 flex-center" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "title-wrapper text-center" }
const _hoisted_4 = {
  key: 0,
  class: "message-wrapper text-center"
}
const _hoisted_5 = {
  key: 0,
  class: "message"
}
const _hoisted_6 = {
  key: 1,
  class: "sub-message"
}
const _hoisted_7 = { class: "mx-auto flex-center" }

import { computed } from 'vue';
import { Button } from "@/components/global";
import { ButtonVariant } from './Button.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    title: {},
    message: {},
    subMessage: {},
    loading: { type: Boolean },
    confirmLoading: { type: Boolean },
    cancelLoading: { type: Boolean },
    confirmDisabled: { type: Boolean },
    cancelDisabled: { type: Boolean },
    confirmText: {},
    cancelText: {},
    confirmButtonVariant: {},
    cancelButtonVariant: {}
  },
  emits: ['cancelModal', 'confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const cancelVariantOrDefault = computed(() => props.cancelButtonVariant || 'outline');
const confirmVariantOrDefault = computed(() => props.confirmButtonVariant || 'default');
const confirmLoadingOrDefault = computed(() => props.confirmLoading ?? props.loading ?? false);
const cancelLoadingOrDefault = computed(() => props.cancelLoading ?? false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.title), 1),
      (__props.message || __props.subMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (__props.message)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.message), 1))
              : _createCommentVNode("", true),
            (__props.subMessage)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.subMessage), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(Button), {
          class: "cancel-btn action-btn text-capitalize",
          variant: cancelVariantOrDefault.value,
          size: "sm",
          testId: "close-dialog",
          loading: cancelLoadingOrDefault.value,
          disabled: confirmLoadingOrDefault.value || __props.cancelDisabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancelModal')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.cancelText ?? 'cancel'), 1)
          ]),
          _: 1
        }, 8, ["variant", "loading", "disabled"]),
        _createVNode(_unref(Button), {
          class: "action-btn text-capitalize",
          size: "sm",
          testId: "confirm-dialog-action",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm'))),
          loading: confirmLoadingOrDefault.value,
          disabled: cancelLoadingOrDefault.value || __props.confirmDisabled,
          variant: confirmVariantOrDefault.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.confirmText ?? 'yes'), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled", "variant"])
      ])
    ])
  ]))
}
}

})